import React from 'react';
import { Link } from 'react-router-dom';
import { usePublicTr } from '../contexts/PublicLanguageContext';
import './ComingSoon.css';

const ComingSoon: React.FC = () => {
  const tr = usePublicTr();

  return (
    <div className="coming-soon-container">
      <div className="coming-soon-content">
        <div className="coming-soon-icon">
          <img src="/logo192.png" alt="Yarnboard" style={{ width: 120, height: 120, borderRadius: 28, objectFit: 'cover' }} />
        </div>
        
        <h1 className="coming-soon-title">
          {tr('Coming Soon', 'Próximamente', 'Em Breve')}
        </h1>
        
        <p className="coming-soon-subtitle">
          {tr('Yarnboard is Currently in Private Beta', 'Yarnboard está actualmente en Beta Privada', 'O Yarnboard está atualmente em Beta Privado')}
        </p>

        <div className="beta-info">
          <div className="info-card">
            <span className="info-icon">🚀</span>
            <h3>{tr('Public Launch', 'Lanzamiento Público', 'Lançamento Público')}</h3>
            <p>{tr('Early 2025', 'Principios de 2025', 'Início de 2025')}</p>
          </div>

          <div className="info-card">
            <span className="info-icon">🧪</span>
            <h3>{tr('Current Beta', 'Beta Actual', 'Beta Atual')}</h3>
            <p>
              {tr('Testing with select users', 'Probando con usuarios seleccionados', 'Testando com usuários selecionados')}
            </p>
          </div>

          <div className="info-card">
            <span className="info-icon">✨</span>
            <h3>{tr('Status', 'Estado', 'Status')}</h3>
            <p>
              {tr('Refining core features', 'Refinando características principales', 'Refinando os recursos principais')}
            </p>
          </div>
        </div>

        <div className="beta-details">
          <h2>{tr('What Does This Mean?', '¿Qué Significa Esto?', 'O Que Isso Significa?')}</h2>
          <p>
            {tr('We\'re currently in private beta, fine-tuning Yarnboard with a select group of users. This allows us to ensure that when we launch publicly, the experience is exceptional.', 'Estamos actualmente en fase de beta privada, perfeccionando Yarnboard con un grupo selecto de usuarios. Esto nos permite asegurar que cuando lancemos públicamente, la experiencia sea excepcional.', 'Estamos em beta privado, ajustando o Yarnboard com um grupo selecionado de usuários. Assim garantimos que, quando lançarmos publicamente, a experiência esteja excepcional.')}
          </p>

          <div className="progress-section">
            <h3>{tr('What We\'re Working On:', 'En Qué Estamos Trabajando:', 'No Que Estamos Trabalhando:')}</h3>
            <ul className="progress-list">
              <li>
                <span className="status complete">✓</span>
                <span>{tr('Core functionality', 'Funcionalidad principal', 'Funcionalidade principal')}</span>
              </li>
              <li>
                <span className="status complete">✓</span>
                <span>{tr('OCR & tagging AI', 'OCR e IA de etiquetado', 'OCR e IA de etiquetamento')}</span>
              </li>
              <li>
                <span className="status complete">✓</span>
                <span>{tr('Video transcription', 'Transcripción de video', 'Transcrição de vídeo')}</span>
              </li>
              <li>
                <span className="status in-progress">⟳</span>
                <span>{tr('Visual mind mapping', 'Mapas mentales visuales', 'Mapas mentais visuais')}</span>
              </li>
              <li>
                <span className="status in-progress">⟳</span>
                <span>{tr('Payment integration', 'Integración de pagos', 'Integração de pagamentos')}</span>
              </li>
              <li>
                <span className="status pending">○</span>
                <span>{tr('Mobile app', 'Aplicación móvil', 'Aplicativo móvel')}</span>
              </li>
              <li>
                <span className="status pending">○</span>
                <span>{tr('Browser extension', 'Extensión de navegador', 'Extensão de navegador')}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="waitlist-section">
          <h2>{tr('Join Us!', '¡Únete a Nosotros!', 'Venha com a Gente!')}</h2>
          <p>
            {tr('Sign up now and get early access when we open the beta to the public. Early adopters will get premium features free for 3 months.', 'Regístrate ahora y obtén acceso anticipado cuando abramos la beta al público. Los primeros usuarios obtendrán características premium de forma gratuita durante 3 meses.', 'Cadastre-se agora e ganhe acesso antecipado quando abrirmos o beta ao público. Quem chegar cedo ganha os recursos premium de graça por 3 meses.')}
          </p>
          
          <div className="waitlist-benefits">
            <div className="benefit">
              <span className="benefit-icon">🎁</span>
              <span>{tr('3 months free Premium', '3 meses gratis de Premium', '3 meses de Premium grátis')}</span>
            </div>
            <div className="benefit">
              <span className="benefit-icon">⚡</span>
              <span>{tr('Priority access', 'Acceso prioritario', 'Acesso prioritário')}</span>
            </div>
            <div className="benefit">
              <span className="benefit-icon">💬</span>
              <span>{tr('Influence features', 'Influye en las características', 'Influencie os recursos')}</span>
            </div>
          </div>

          <Link to="/register" className="waitlist-button">
            {tr('Sign Up for Early Access', 'Registrarse Para Acceso Anticipado', 'Cadastrar Para Acesso Antecipado')}
          </Link>
        </div>

        <div className="back-link">
          <Link to="/welcome">
            ← {tr('Back to Home', 'Volver al Inicio', 'Voltar ao Início')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
